import { Component } from '@angular/core';
import { ModalService } from '../../../services/modal/modal.service';
import { BaseModalComponent } from '../base-modal.component';
import { Utils } from '../../../../../common/js/Utils';
import { ActivatedRoute, Router } from '@angular/router';
import { POLICY_TYPES } from '../../../../../common/js/constants/policy';
import { PaymentModalType } from '../../../../../coverpath-common/js/interfaces/CoverpathTypes';

@Component({
  moduleId: module.id,
  templateUrl: './authorize-payment.component.html',
})
export class AuthorizePaymentComponent extends BaseModalComponent {
  confirm() {}
  cancel() {}
  nextPaymentDate: string;
  totalPremium: string;
  payerName: string;
  policyNumber: string;
  useSecondary: boolean = false;
  effectiveDraftDate: string;
  accountType: string;
  bankAccountLastFour: string;
  paymentDatePast: boolean;
  paymentFailureDate: string;
  invoiceId: string;
  hasPaymentFailed: boolean;
  isAnnualPayment: boolean;
  isAutoPay: boolean;
  isBillingPaused: boolean;

  constructor(modalService: ModalService, private router: Router, private activatedRoute: ActivatedRoute) {
    super(modalService);
  }

  ngOnInit() {
    const policy = this.data.modalData.policy;
    const paPolicyData = this.data.modalData.paPolicyData;
    this.policyNumber = policy.policyNumber;
    this.useSecondary = paPolicyData.policyType === POLICY_TYPES.SECONDARY;
    const rawPremium = paPolicyData.cacPaymentData.getCACTotalPremiumFromPolicyInfo();
    this.paymentDatePast = paPolicyData.cacPaymentData.getCACNextPaymentDisplayDDBPast();
    this.hasPaymentFailed = paPolicyData.cacPaymentData.getCACHasPaymentFailed();
    this.totalPremium = Utils.formatCurrency(rawPremium, 2);

    if (this.hasPaymentFailed) {
      this.totalPremium = Utils.formatCurrency(paPolicyData.cacPaymentData.failedPaymentAmount, 2);
    }
    this.payerName = paPolicyData.cacPaymentData.payerName;
    this.effectiveDraftDate = paPolicyData.cacPaymentData.effectiveDraftDate;
    this.bankAccountLastFour = paPolicyData.cacPaymentData.bankAccountLastFour;
    this.accountType = paPolicyData.cacPaymentData.getCACBankAccountClassification();
    this.invoiceId = paPolicyData.cacPaymentData.invoiceId;
    this.paymentFailureDate = Utils.formatMonthWithOrdinalDay(paPolicyData.cacPaymentData.paymentFailureDate);
    this.nextPaymentDate = Utils.formatDate(
      this.hasPaymentFailed ? new Date() : paPolicyData.cacPaymentData.getCACNextPaymentDisplayDDB()
    );
    this.isAnnualPayment = paPolicyData.cacPaymentData.paymentFrequency === 'annual';
    this.isAutoPay = paPolicyData.cacPaymentData.isAutoPay;
    this.isBillingPaused = paPolicyData.cacPaymentData.isBillingPaused;
  }

  closeModal(): void {
    this.modalService.deactivate();
  }

  updateComplete(): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        submissionStatus: 'success',
        submissionType: this.hasPaymentFailed ? PaymentModalType.PAYMENT_RETRY : PaymentModalType.PAYMENT_AUTHORIZATION,
        policyType: this.data.modalData.paPolicyData.policyType,
        showPaymentDate: !this.paymentDatePast,
      },
      queryParamsHandling: 'merge',
    });
  }
}
